import React from "react"
import { useTranslation } from "react-i18next"

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@f2e/ui/components/base"

export type FeedbackFilterValue =
  | "no_filter"
  | "no_feedback"
  | "with_feedback"
  | "helpful_feedback"
  | "improve_feedback"

interface FeedbackSelectProps {
  defaultValue?: FeedbackFilterValue
  compact?: boolean
  onFeedbackChange?: (value: FeedbackFilterValue) => void
}

const FeedbackSelect = ({
  defaultValue = "no_filter",
  compact = false,
  onFeedbackChange,
}: FeedbackSelectProps) => {
  const { t } = useTranslation()

  const triggerId = "feedback-select"
  return (
    <div
      className={compact ? "grid gap-1.5" : "mb-4 flex items-center space-x-4"}
    >
      <label
        htmlFor={triggerId}
        className={
          compact ? "text-xs font-medium text-muted-foreground" : "font-medium"
        }
      >
        {t("historyList.feedbackSelect.label")}
      </label>
      <Select
        onValueChange={(value) =>
          onFeedbackChange?.(value as FeedbackFilterValue)
        }
        defaultValue={defaultValue}
      >
        <SelectTrigger
          id={triggerId}
          className={compact ? "h-9 w-full min-w-0 text-sm" : "w-[180px]"}
        >
          <SelectValue
            placeholder={t("historyList.feedbackSelect.placeholder")}
          />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="no_filter" className="pl-6">
            {t("historyList.feedbackSelect.none")}
          </SelectItem>
          <SelectItem value="no_feedback" className="pl-6">
            {t("historyList.feedbackSelect.noFeedback")}
          </SelectItem>
          <SelectItem value="with_feedback" className="pl-6">
            {t("historyList.feedbackSelect.withFeedback")}
          </SelectItem>
          <SelectItem value="helpful_feedback" className="pl-6">
            {t("historyList.feedbackSelect.helpful")}
          </SelectItem>
          <SelectItem value="improve_feedback" className="pl-6">
            {t("historyList.feedbackSelect.improve")}
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  )
}

export default React.memo(FeedbackSelect)
